export default __webpack_public_path__ + "static/media/bannerTourExample1.3dd70ea0.svg";